/**
 * Matches the backend's `providerType` field on SchedulingProjectDataSource.
 *
 * A type string is only meaningful together with a providerKind: the same string repeats across
 * kinds and denotes a different provider each time (SERVICE_TIME + MDLZ_PROJECTION is not the
 * same thing as UNITS + MDLZ_PROJECTION), which is why the two always travel together.
 *
 * Only Projection and Prediction are offered in the UI (SITE_PROVIDER_TYPE_OPTIONS). The weighted
 * variants stay here so a record that already carries one still renders with a proper label.
 */
export enum SiteProviderType {
  Projection = "MDLZ_PROJECTION",
  ProjectionWeighted = "MDLZ_PROJECTION_WEIGHTED",
  ProjectionByCasePerHourWeighted = "MDLZ_PROJECTION_BY_CASE_PER_HOUR_WEIGHTED",
  Prediction = "MDLZ_PREDICTION"
}
